<template>
  <v-main>
    <v-container fluid class="pt-1">
      <router-view></router-view>
    </v-container>
  </v-main>
</template>

<script>
export default {
  props: {
    source: String,
  },
};
</script>

<style lang="scss"></style>
